import {dialog, GridLayout, IDialog} from '@Common/Controls';
import UrlHelper from '@Common/Helpers/UrlHelper';

export interface IConfirmationDialogParameters {
    title?: string;
    text?: string;
    width?: any;
    threeOptions?: boolean;
    hideCancel?: boolean;
    resizable?: boolean;
    canSwitchToFullScreen?: boolean;
    yesText?: string;
    noText?: string;
}

export const enum ConfirmationResult {
    yes = 1,
    no = 0,
    cancel = -1
}

export function confirmationDialog(param: IConfirmationDialogParameters): ConfirmationDialog {
    return new ConfirmationDialog(param);
}

export class ConfirmationDialog {
    private promiseResolve: ICallback<ConfirmationResult> = _.noop;

    private _yes: IHandler;

    private _no: IHandler;

    private _cancel: IHandler;

    private readonly dialog: IDialog;

    private readonly root: GridLayout;

    constructor(private readonly param: IConfirmationDialogParameters) {
        this.param = _.defaults<IConfirmationDialogParameters, IConfirmationDialogParameters>(this.param, {
            title: strings.confirmation,
            text: '',
            width: 'auto',
            threeOptions: true,
            yesText: strings.yes,
            noText: strings.no
        });

        this.yes(_.noop);
        this.no(_.noop);
        this.cancel(_.noop);

        this.root = this.getLayout();
        this.dialog = this.createDialog();
    }

    public show(): Promise<ConfirmationResult> {
        this.dialog.wrap(this.root.getControl());
        return new Promise(resolve => (this.promiseResolve = resolve));
    }

    public yes(fn: IHandler): this {
        if (_.isFunction(fn)) {
            this._yes = this.makeEvent(ConfirmationResult.yes, fn);
        }

        return this;
    }

    public no(fn: IHandler): this {
        if (_.isFunction(fn)) {
            this._no = this.makeEvent(ConfirmationResult.no, fn);
        }

        return this;
    }

    public cancel(fn: IHandler): this {
        if (_.isFunction(fn)) {
            this._cancel = this.makeEvent(ConfirmationResult.cancel, fn);
        }

        return this;
    }

    private getLayout(): GridLayout {
        return new GridLayout({
            columns: [{ style: { width: 'auto', verticalAlign: 'top' } }, {}],
            rows: [{}],
            cells: [
                {
                    columnIndex: 0,
                    rowIndex: 0,
                    content: $(`<img src="${UrlHelper.getImageUrl('Dialog/question')}" />`)
                },
                {
                    columnIndex: 1,
                    rowIndex: 0,
                    className: 'gap-2-left text-wrap',
                    content: this.param.text
                }
            ]
        });
    }

    private createDialog(): IDialog {
        const dlg = dialog({
            title: this.param.title,
            width: this.param.width,
            cancelText: this.param.noText,
            okText: this.param.yesText,
            buttons: [
                {
                    text: this.param.noText,
                    ready: () => {
                        if (this.param.threeOptions) {
                            this._no();
                        } else {
                            this._cancel();
                        }

                        dlg.remove();
                    }
                }
            ]
        });

        dlg.ok(() => this._yes());
        dlg.cancel(() => this._cancel());

        dlg.onClose(() => {
            this.root.destroy();
        });

        return dlg;
    }

    private makeEvent(res: ConfirmationResult, fn: IHandler): IHandler {
        return () => {
            fn();
            this.promiseResolve(res);
        };
    }
}
